import { isNullish, isDraftWaypoint, decryptDraftWaypoint, getDraftWaypointAccessAttributes, maybeEncryptValue, shouldEncryptValueAtPath } from '@caresend/utils';

/**
 * Returns the decrypted type of an item if it is encrypted.
 *
 * For example, if we have a draft waypoint with encrypted fields, we can
 * decrypt each of them and return the unencrypted item.
 *
 * Note: This only supports draft waypoints for now.
*/
const maybeGetDecryptedItems = async (value) => {
    if (isNullish(value))
        return;
    const result = { ...value };
    await Promise.all(Object.entries(value).map(async ([key, item]) => {
        if (isDraftWaypoint(item)) {
            result[key] = await decryptDraftWaypoint(item);
        }
    }));
    return result;
};
/**
 * Checks if a value at a given path should be encrypted for database storage.
 * If so, it encrypts the value.
 *
 * Note: This only supports draft waypoints for now.
 */
const maybeGetEncryptedValue = async (path, value) => {
    try {
        const accessAttributes = await getDraftWaypointAccessAttributes(path);
        return maybeEncryptValue(value, accessAttributes, () => shouldEncryptValueAtPath(path, value));
    }
    catch (error) {
        console.error('Error getting maybe encrypted value: ', error);
        return value;
    }
};

export { maybeGetDecryptedItems, maybeGetEncryptedValue };
